export const DEFAULT_HEADER_IMAGE_LP =
  'https://cdn-diy-public.classplus.co/assets/icons/landing-pages-default-logo.png';
